import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_INPUT_GENERICO, ESTILO_BOTON_GENERAL_CANCELAR } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
import Spinner from "../../components/spinner";
import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { actualizarEstadosIncidente, crearEstadosIncidente } from "../../api/api-estados-incidente";
import { obtenerListaPersona } from "../../api/api-persona";
import Select from "react-select";
import DynamicFormularioIncidenteBuilder from "../../components/dynamic-formulario-incidente";

export default function EstadoIncidentePage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  // const [listaCategoria, setListaCategoria] = useState([]);
  // const [categoriaSelected, setCategoriaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  const [requestSend, setRequestSend] = useState(false);
  const [dynamicFields, setDynamicFields] = useState([]);

  const [listaPersonas, setListaPersonas] = useState([]);
  const [personasSelected, setPersonasSelected] = useState(null);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
        // Initialize dynamic fields if they exist
        if (Array.isArray(data.params.dynamicFields)) {
          setDynamicFields(data.params.dynamicFields);
        }
      }
      const personas = await obtenerListaPersona({ habilitado: 1 }, true);
      setListaPersonas(personas);
      if (data.params.listaPersonas !== undefined && data.params.listaPersonas !== null) {

        setPersonasSelected(JSON.parse(data.params.listaPersonas));
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (Array.isArray(dynamicFields) && dynamicFields.length === 0) {
        message = message + t("alert_debe_ingresar_al_menos_un_campo_de_requerimiento") + '\n';
      }

      // Validate labels and keys
      const keySet = new Set();
      for (let i = 0; i < dynamicFields.length; i++) {
        const field = dynamicFields[i];

        // Validate label: must have more than 2 characters
        if (!field.label || String(field.label).trim().length <= 2) {
          const errorMsg = t("alert_label_debe_tener_mas_de_2_caracteres") + ` (${t("label_campo")} ${i + 1})`;
          showToast(errorMsg, "error", 4000);
          return false;
        }

        // Validate key: must be unique
        if (!field.key || String(field.key).trim().length === 0) {
          const errorMsg = t("alert_key_no_puede_estar_vacio") + ` (${t("label_campo")} ${i + 1})`;
          showToast(errorMsg, "error", 4000);
          return false;
        }

        if (keySet.has(field.key)) {
          const errorMsg = t("alert_key_debe_ser_unico") + `: "${field.key}" (${t("label_campo")} ${i + 1})`;
          showToast(errorMsg, "error", 4000);
          return false;
        }

        keySet.add(field.key);
      }

      if (message.length > 0) {
        showToast(message.trim(), "warning", 4000);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    // objEnviar.idCategoria = categoriaSelected !== null ? categoriaSelected.value : null;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.dynamicFields = dynamicFields;
    objEnviar.listaPersonas = personasSelected;
    // console.log('objEnviar');
    // console.log(objEnviar);
    // return;
    setRequestSend(true);
    setProcessingVisible(true);
    try {
      if (formData.id === 0) {
        // console.log('crear correo');
        const response = await crearEstadosIncidente(objEnviar);
        setProcessingVisible(false);
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (formData.id !== 0) {
        // console.log('actualizar correo');
        const response = await actualizarEstadosIncidente(objEnviar);
        setProcessingVisible(false);
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (err) {
      console.log('handleSaveClick err');
      console.log(err);
      setProcessingVisible(false);
    } finally {
      setRequestSend(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData?.codigo ?? ""}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData?.codigo?.length ?? 0}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData?.descripcion ?? ""}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData?.descripcion?.length ?? 0}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData?.nota ?? ""}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData?.nota?.length ?? 0}/{charLimits.nota}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
                <label
                  htmlFor="notificar_a"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_notificar_a")}
                </label>
                <Select
                  options={listaPersonas}
                  value={personasSelected}
                  onChange={(option) => setPersonasSelected(option)}
                  placeholder={t("placeholder_seleccione_persona")}
                  isClearable={true}
                  isSearchable={true}
                  isMulti={true}
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 999 }),
                    menu: (base) => ({ ...base, zIndex: 999 }),
                  }}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <DynamicFormularioIncidenteBuilder
                  fields={dynamicFields}
                  setFields={setDynamicFields}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                  {requestSend === false && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      {t("label_aceptar")}
                    </button>
                  )}
                  {requestSend === true && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      disabled
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Spinner size="sm" color="white" />
                        <span>{t("label_aceptar")}</span>
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
